<template>
  <div ref="layout" class="page-container">
    <div class="query-title">发货运费设置查询</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-form-item class="widget-view" label="营销中心" label-width="">
                    <el-select
                      v-model="conditions.saleCenter_name"
                      @focus="openDialog($event, '营销中心')"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="仓库名称">
                    <el-input v-model="conditions.warehouse" />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="产品">
                    <el-select
                      v-model="conditions.productIds_name"
                      @focus="openDialog($event, '产品选择')"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="明细信息"
          :custome-config="() => vxeShowCustom('gridOptions')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button>
            <table-button name="add" tip="增加" @click="insertData" />
          </template>
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          />
        </TableCommon>
      </div>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiFindShippingFeeDetail } from '@/api/applyForGoods/shippingfee'
import OrgSelect from '@/components/dialog/OrgSelect'
import ProductSelect from '@/components/dialog/ProductSelect'
export default {
  components: {
    OrgSelect,
    ProductSelect
  },

  data() {
    return {
      addForm: {},
      dialogTitle: '',
      showDialog: false,
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        productIds: '',
        productIds_name: '',
        saleCenter: '',
        saleCenter_name: '',
        warehouse: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          { field: 'saleCenterName', title: '营销中心', width: 120 },
          { field: 'channelTypeTextView', title: '渠道', width: 120 },
          { field: 'warehouse', title: '仓库名称', width: 120 },
          { field: 'freightPrice', title: '运费单价', width: 120 },
          { field: 'shipcitycode', title: '启运城市编码', width: 120 },
          { field: 'saleCenterName', title: '启运城市名称', width: 120 },
          { field: 'productIds', title: '产品编码', width: 120 },
          { field: 'productIds', title: '产品名称', width: 120 },
          { field: 'createdByName', title: '创建时间', width: 120 },
          { field: 'createdDate', title: '创建人', width: 120 }
        ],
        data: []
      }
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 处理分页事件
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      if (this.queryData) {
        this.queryData()
      }
    },
    async queryData(page) {
      page && (this.pagination.page = page)
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      this.loading = true
      const { data } = await apiFindShippingFeeDetail(params)
      this.gridOptions.data = data.Rows
      this.pagination.totalCount = data.Total
      this.loading = false
    },
    reset() {
      this.conditions = {
        productIds: '',
        productIds_name: '',
        saleCenter: '',
        saleCenter_name: '',
        warehouse: ''
      }
    },
    insertData() {
      this.$router.push({
        path: '/wly/to-goods/base-setting/delivery-fee-setting'
      })
    },
    openDialog(e, title) {
      e.target.blur()
      this.dialogTitle = title
      this.showDialog = true
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        if (this.dialogTitle === '产品选择') {
          this.conditions.productIds = data.productCode
          this.conditions.productIds_name = data.productShortName
        } else {
          this.conditions.saleCenter = data.code
          this.conditions.saleCenter_name = data.name
        }
      }
      this.showDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliveryFeeSettingQuery.vue